// 导入浏览器内置的fetch API
const BASE_URL = 'http://8.130.14.101:60000/api/NewManage';

/**
 * 通用请求方法
 * @param {string} url - 请求路径
 * @param {string} method - 请求方法
 * @param {Object} data - 请求数据
 * @returns {Promise} - 返回Promise对象
 */
async function request(url, method = 'GET', data = null) {
  // 从localStorage获取token
  const token = localStorage.getItem('token')

  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  // 如果有token，添加到请求头
  if (token) {
    options.headers['X-Token'] = token
  }

  if (data) {
    options.body = JSON.stringify(data);
  }

  try {
    const response = await fetch(`${BASE_URL}${url}`, options);
    const result = await response.json();
    // 如果返回的消息包含"拒绝授权"，替换为更友好的提示
    if (result && result.msg && result.msg.includes('拒绝授权')) {
      result.msg = '账号已下线，请重新登录'
    }
    return result;
  } catch (error) {
    console.error('请求错误:', error);
    throw error;
  }
}

// 导出request方法，方便后续添加其他接口
export default request;

import { getAction,postAction,getBlobAction } from './manage'
import { postHebeiAction } from './manageHebei'
import { getAliAction } from './manageAli'

// 登录接口
const login = (data) => postAction('/NewManage/login', data)
//获取公告列表接口
const getAnnouncementList = (data) => postAction('/getAnnouncementList', data)
//新增公告接口
const addAnnouncement = (data) => postAction('/addAnnouncement', data)
//编辑公告接口
const editAnnouncement = (data) => postAction('/editAnnouncement', data)
//查课
const chaKeApi = (data) => postAction('/NewManage/ChaKe', data)
//查课 河北开放大学
const chaKeHebeiApi = (data) => postHebeiAction('/query/course', data)
//下单
const submitOrderApi = (data, urlParams = '') => postAction(`/NewManage/TiJiao${urlParams ? '?' + urlParams : ''}`, data)
//批量下单
const batchSubmitOrderApi = (data) => postAction('/batchSubmitOrder', data)
//国开批量下单
const batchGuokaiApi = (data) => postAction('/NewManage/TiJiao', data)
//批量查课
const batchChaKeApi = (data) => postAction('/NewManage/PiLiangChaKe', data)
//获取批量查课进度
const getBatchChaKeProgress = () => getAction('/NewManage/GetPiLiangChaKeJinDu')
//下载批量查课结果
const downloadBatchChaKeResult = () => getBlobAction('/NewManage/DownLoadPiLiangChaKeJieGuo')
//上传Excel文件
const uploadExcelApi = (data) => postAction('/uploadExcel', data)
//上传xls文件
const uploadXlsApi = (data, Model = '') => {
  const token = localStorage.getItem('token')
  return postAction(`/NewManage/UploadXls?token=${token}${Model ? '&Model=' + Model : ''}`, data)
}
//实验学院 上传xls文件
const uploadXlsShiyanApi = (data, Model = '') => {
  const token = localStorage.getItem('token')
  return postAction(`/NewManage/ShiYanUploadXls?token=${token}${Model ? '&Model=' + Model : ''}`, data)
}
//获取Excel解析内容
const getExcelContentApi = (data) => postAction('/getExcelContent', data)

// 获取订单列表
const getOrderList = (data) => getAction('/NewManage/getOrderList', data)

// 重做订单
const redoOrder = (data) => postAction('/redoOrder', data)

// 提交问题反馈
const submitFeedback = (data) => postAction('/submitFeedback', data)

// 代理管理相关接口
// 获取代理列表
const getAgentList = (data) => getAction('/NewManage/GetDaiLiListInfo', data)

// 新增代理
const addAgent = (data) => postAction('/NewManage/AddDaiLi', data)

// 编辑代理
const updateAgent = (data) => postAction('/NewManage/UpDataDaiLi', data)

// 代理充值
const rechargeAgent = (data) => getAction('/NewManage/ChongZhi', data)

// 禁用/启用代理
const toggleAgentStatus = (data) => postAction('/NewManage/JinYong', data)

// 消费记录相关接口
// 获取消费记录列表
const getConsumptionList = (data) => getAction('/getCustList', data)

// 问题反馈相关接口
// 获取问题反馈列表
const getQuestionList = (data) => getAction('/Question/GetQuestionList', data)

// 新增问题反馈
const addFeedback = (data) => postAction('/Question/Add', data)
 
// 新增问题反馈 河北开放大学
const addFeedbackHebei = (data) => postHebeiAction('/feedback', data)

// 回复问题反馈
const replyFeedback = (data) => postAction('/Question/Reply', data)

// 修改密码接口
const changePassword = (data) => getAction('/NewManage/ChangePassWord', data)

// 获取个人信息接口
const getUserInfo = () => getAction('/NewManage/userinfo')

// 批量重刷订单
const batchChongShua = (data) => postAction('/NewManage/ChongShua', data)

// 获取公告内容
const getGongGao = () => getAction('/NewManage/GetGongGao')

// 更新公告接口
const updateGongGao = (data) => postAction('/NewManage/UpdateGongGao', data)

//实验学院 查课接口
const chakeShiyan = (data) => postAction('/NewManage/ShiYanChaKe', data)
//实验学院 提交口
const tijiaoShiyan = (data) => postAction('/NewManage/ShiYanTiJiao', data)
//河北开放大学 提交口
const tijiaoHebei = (data) => postHebeiAction('/submit', data)
//实验学院 获取订单列表 NewManage/ShiYanGetOrderList
const getOrderListShiyan = (data) => getAction('/NewManage/ShiYanGetOrderList', data)
//河北开放大学 获取订单列表
const getOrderListHebei = (data) => postHebeiAction('/order/query', data)
//实验学院 批量提交
const batchSubmitOrderShiyan = (data) => postAction('/NewManage/ShiYanUploadXls', data)
//实验学院 批量重刷
const batchChongShuaShiyan = (data) => postAction('/NewManage/ShiYanChongShua', data)
//河北开放大学 批量重刷
const batchChongShuaHebei = (data) => postHebeiAction('/batch/refresh', data)
//实验大学订单导出
const shiyanExport = (data) => getAliAction('/order/export', data)


export {
  login,
  getAnnouncementList,
  addAnnouncement,
  editAnnouncement,
  updateGongGao, // 导出更新公告接口
  chaKeApi,
  submitOrderApi,
  batchSubmitOrderApi,
  uploadExcelApi,
  uploadXlsApi,
  uploadXlsShiyanApi,
  getExcelContentApi,
  getOrderList,
  redoOrder,
  submitFeedback,
  // 导出代理管理相关接口
  getAgentList,
  addAgent,
  updateAgent,
  rechargeAgent,
  toggleAgentStatus,
  getConsumptionList,
  getQuestionList, // 导出新的问题反馈列表接口
  addFeedback,
  replyFeedback,
  changePassword, // 导出修改密码接口
  getUserInfo, // 导出获取个人信息接口
  batchChongShua, // 导出批量重刷接口
  getGongGao, // 导出获取公告接口
  chakeShiyan, // 实验学院 查课接口
  tijiaoHebei, // 河北开放大学 提交接口
  tijiaoShiyan, // 实验学院 提交口接口
  getOrderListShiyan, // 实验学院 获取订单列表接口
  batchSubmitOrderShiyan, // 实验学院 批量提交接口
  batchChongShuaShiyan,
  chaKeHebeiApi,
  getOrderListHebei,//河北开放大学订单列表
  batchChongShuaHebei, //河北开放大学批量重刷
  addFeedbackHebei, //河北开放大学反馈
  shiyanExport,
  batchGuokaiApi,
  batchChaKeApi,
  getBatchChaKeProgress,
  downloadBatchChaKeResult,
}
